// Utils
import { required } from '@shopee/validators';
import { prettifyPhoneNumber } from '@shopee-user/authentication-utils';
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';

// Enums
import { Feature } from '@shopee-user/feature-toggle';

const removeAllWhiteSpaceTransform = (username: string) => {
  return username.replace(/\s+/g, '');
};

const authKeyConfig = isFeatureEnabled(Feature.LoginByPasswordAllowPhone)
  ? {
      name: 'authKey',
      initial: '',
      validators: [required('msg_auth_mandatory_field')],
      transform: (authKey: string) => prettifyPhoneNumber(authKey.trim()),
    }
  : {
      name: 'authKey',
      initial: '',
      validators: [required('msg_auth_mandatory_field')],
      transform: removeAllWhiteSpaceTransform,
    };

export const FORM_CONFIG = [
  authKeyConfig,
  {
    name: 'password',
    initial: '',
    validators: [required('msg_auth_mandatory_field')],
  },
];
